import { useCallback, useState } from "react";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { AccordionSummary } from "@mui/material";
import HTMLReactParser from "html-react-parser";
import { ExpandCircleDownOutlined } from "@mui/icons-material";

interface PropsAccordion {
    children: React.ReactNode,
    header?: string,
    color?: string,
    bgColor?: string,
    borderColor?: string
}

const AccordionFund: React.FC<PropsAccordion> = ({ children, header, color, bgColor, borderColor = "1px solid #e79a09" }) => {
    const [expanded, setExpanded] = useState(true);
    const handleChange = useCallback(() => setExpanded(!expanded), [expanded])
    return (
        <MuiAccordion disableGutters elevation={0} expanded={expanded} sx={{ border: borderColor, borderRadius: "20px !important" }}>
            <AccordionSummary
                onClick={handleChange}
                expandIcon={<ExpandCircleDownOutlined sx={{ fontSize: '1.5rem', color: "white" }} />}
                sx={{
                    color: color ?? "#ffffff",
                    backgroundColor: bgColor ?? "rgb(102,151,245)",
                    background: "#e79a09",
                    cursor: 'pointer',
                    borderRadius: "20px !important",
                    flexDirection: 'row-reverse',
                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                        transform: 'rotate(180deg)',
                    },
                    '& .MuiAccordionSummary-content': {
                        marginLeft: '8px',
                    },
                    alignItems: "center",
                    '& .MuiAccordionSummary-expandIconWrapper': {
                        margin: "0"
                    }
                }}
            >
                <Typography className="font-medium">{HTMLReactParser(header)}</Typography>
            </AccordionSummary>
            <MuiAccordionDetails sx={{ mt: 2 }}>
                {children}
            </MuiAccordionDetails>
        </MuiAccordion>
    )
}
export default AccordionFund